var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsuarios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1256 26.7342L24.6619 25.5704C24.4271 24.9798 24.064 24.4504 23.5973 24.0187L23.5127 23.94C22.7792 23.2604 21.8167 22.8812 20.8163 22.8812H14.1808C13.1804 22.8812 12.2165 23.2604 11.4829 23.9385L11.3983 24.0173C10.9331 24.449 10.57 24.9783 10.3338 25.569L9.87292 26.7342",
    stroke: "#0096D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7754 11.5646C22.5838 13.3729 22.5838 16.3056 20.7754 18.1154C18.9671 19.9252 16.0344 19.9237 14.2246 18.1154C12.4148 16.3071 12.4163 13.3744 14.2246 11.5646C16.0329 9.75479 18.9656 9.75625 20.7754 11.5646",
    stroke: "#0096D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7083 30.625H7.29167C5.68021 30.625 4.375 29.3198 4.375 27.7083V7.29167C4.375 5.68021 5.68021 4.375 7.29167 4.375H27.7083C29.3198 4.375 30.625 5.68021 30.625 7.29167V27.7083C30.625 29.3198 29.3198 30.625 27.7083 30.625Z",
    stroke: "#0096D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.d1b26fcf2fc47e0e89426c4030eac11e.svg";
export { ForwardRef as ReactComponent };